<template>
  <!-- 
    画面: 会員割引一覧
    用途: オペレータが会員の割引一覧(過去分を含む)を参照する
   -->
  <div>
    <CRow>
      <CCol lg="12">

        <!-- #region 会員情報 -->
        <CCard>
          <CCardHeader>
            <h3 class="card-title">会員情報</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <MemberInfo />
          </CCardBody>
          <CCardFooter class="px-5"> </CCardFooter>
        </CCard>
        <!-- #endregion 会員情報 -->

        <!-- #region 会員割引一覧 -->
        <CCard>
          <CCardHeader>
            <h3 class="card-title">会員割引一覧</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <MemberDiscountListTable />
          </CCardBody>
          <CCardFooter class="px-5"> </CCardFooter>
        </CCard>
        <!-- #endregion 会員割引一覧 -->

      </CCol>
    </CRow>
  </div>
</template>

<script>
import MemberDiscountListTable from "./components/MemberDiscountListTable.vue";
import MemberInfo from "./components/MemberInfo.vue";

export default {
  name: "MemberDiscountList",

  components: {
    MemberDiscountListTable,
    MemberInfo
  },

  data() {
    return {
    };
  },

  created() {
  },

  methods: {},
  
};
</script>

<style lang="scss">
.nav-tabs {
  margin-bottom: -1px;
  .nav-link {
    border: 1px solid #cccccc;
    color: #4b5e80;
    &.active {
      background: #cccccc;
      border: 1px solid #cccccc;
      color: #454579;
      font-weight: bold;
    }
  }
}
</style>
